import ViewExtensionViewModel from "@/ViewModels/Views/ViewExtensionViewModel";
import RADApplication from "@/Management/RADApplication";
import ComponentManager from "@/Management/ComponentManager";
import NavigationService from "@/Management/NavigationService";
import { ITasksForTypeDTO } from "coreframetypings/dto";
import StartpageGroupViewModelT from "@/ViewModels/Controls/StartpageGroupViewModel";
import StartpageElementViewModelT from "@/ViewModels/Controls/StartpageElementViewModel";
import LabelViewModelT from "@/ViewModels/Controls/LabelViewModel";
import ImageViewModelT from "@/ViewModels/Controls/ImageViewModel";
import LinkViewModelT from "@/ViewModels/Controls/LinkViewModel";
import LinkViewModelBuilder from "@/Builder/LinkViewModelBuilder";
import BreadCrumbViewModelT from "@/ViewModels/Controls/BreadCrumbViewModel";
import ActivityFeedViewModelT from "@/Components/ActivityFeed/ActivityFeedViewModel";
export default class StartpageViewModel extends ViewExtensionViewModel {
    public pageTitle: any;
    private StartpageGroupViewModel = ComponentManager.getViewModel<typeof StartpageGroupViewModelT>("StartpageGroupViewModel");
    private StartpageElementViewModel = ComponentManager.getViewModel<typeof StartpageElementViewModelT>("StartpageElementViewModel");
    private ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>("ImageViewModel");
    private LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>("LinkViewModel");
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>("LabelViewModel");
    protected BreadCrumbViewModel = ComponentManager.getViewModel<typeof BreadCrumbViewModelT>("BreadCrumbViewModel");
    private ActivityFeedViewModel = ComponentManager.getViewModel<typeof ActivityFeedViewModelT>("ActivityFeed");

    public favoritesElement: StartpageElementViewModelT;
    public tasksElement: StartpageElementViewModelT;
    public activityFeed: StartpageElementViewModelT;
    public appElement: StartpageElementViewModelT;
    public authElement: StartpageElementViewModelT;
    public adminElement: StartpageElementViewModelT;
    public metaElement: StartpageElementViewModelT;

    public activityGroup: StartpageGroupViewModelT;
    public favAndTaskGroup: StartpageGroupViewModelT;
    public adminGroups: StartpageGroupViewModelT;

    constructor(params: any) {
        super(params);
        this.pageTitle = (() => {
            return new this.BreadCrumbViewModel({
                elements: [
                    new this.LabelViewModel({
                        ergName: "MENU_ITEM_HOME",
                    }),
                ],
            });
        })();

        this.activityGroup = new StartpageGroupViewModelT({
            elements: (() => {
                let elements = [];
                elements.push(
                    new this.StartpageElementViewModel({
                        customElement: "ActivityFeed",
                        customViewModel: new this.ActivityFeedViewModel({}),
                    }),
                );
                return elements;
            })(),
        });

        this.favAndTaskGroup = new StartpageGroupViewModelT({
            elements: () => {
                let elements = [];
                elements.push(
                    new this.StartpageElementViewModel({
                        label: new this.LabelViewModel({
                            ergName: "FAVOURITE_TITLE",
                        }),
                        image: new this.ImageViewModel({
                            alternativeText: new this.LabelViewModel({
                                ergName: "FAVOURITE_TITLE",
                            }),
                        }),
                        items: this.defineComputed(() => {
                            let menuItems = [
                                this.createItem({
                                    ergName: "FAV_STARTPAGE",
                                    url: "/Home",
                                }),
                                this.createItem({
                                    ergName: "SEARCH_TITLE",
                                    url: "/Search",
                                }),
                            ];
                            let menus = RADApplication.getInstance().user.menus();
                            let favoriteTree = menus.userFavoriteTree;
                            if (favoriteTree != null) {
                                for (let i = 0; i < favoriteTree.childNodes.length; i++) {
                                    let item = this.createItem(favoriteTree.childNodes[i]);
                                    menuItems.push(item);
                                }
                            }
                            let favorites =
                                RADApplication.getInstance().user.getUserSpecificData(
                                    "RAD_FAVOURITESITES",
                                    {},
                                )();
                            for (let link in favorites) {
                                let favorite = this.createItem({
                                    favoriteAddress: link,
                                    ergName: favorites[link],
                                });
                                menuItems.push(favorite);
                            }
                            return menuItems;
                        }),
                    }),
                );

                elements.push(
                    new this.StartpageElementViewModel({
                        label: new this.LabelViewModel({
                            ergName: "RADFOUNDATION_SUBSYSTEM_TASKS_ERGNAME",
                        }),
                        items: (() => {
                            let items = [];
                            items.push(this.getMyTasksWithCount());
                            items.push(
                                new this.LinkViewModel({
                                    label: new this.LabelViewModel({
                                        ergName: "TASKS_ALL_TASKS",
                                    }),
                                    onClick: () => {
                                        NavigationService.getInstance().navigateToUrl(
                                            "/ListView?TypeName=RAD.RADFoundation.ProblemDomain.PDTask&ViewName=RAD.RADFoundation.ProblemDomain.PDTask_LV&Filter=" +
                                            encodeURIComponent("this.IsCompleted=false"),
                                        );
                                    },
                                }),
                            );

                            return items;
                        })(),
                    }),
                );

                return elements;
            },
        });

        this.appElement = new this.StartpageElementViewModel({
            label: new this.LabelViewModel({
                ergName:
                    "RAD.RADFoundation.ProblemDomain.Meta.PDApplicationMeta_ERGNAME",
            }),
            items: [
                this.createLink(
                    "History.HistorizationPoint_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.History.HistorizationPoint_LV",
                    "History.HistorizationPoint",
                ),
                this.createLink(
                    "Journal.JournalEntry_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Journal.JournalEntry_LV",
                    null,
                ),
                this.createLink(
                    "PDDocument_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.PDDocument_LV",
                    null,
                ),
                this.createLink(
                    "PDEMail_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.PDEMail_LV",
                    "PDEMail",
                ),
                this.createLink(
                    "Scheduler.PDJob_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Scheduler.PDJob_LV",
                    "Scheduler.PDJob",
                ),
            ],
        });
        this.authElement = new this.StartpageElementViewModel({
            label: new this.LabelViewModel({
                ergName: "RADFoundation_Subsystem_Authorization_ERGNAME",
            }),
            items: [
                this.createLink(
                    "User_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.User_LV",
                    "User",
                ),
                this.createLink(
                    "UserGroup_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.UserGroup_LV",
                    "UserGroup",
                ),
                this.createLink(
                    "UserMemberOf_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.UserMemberOf_LV",
                    null,
                ),
                this.createLink(
                    "Rights.ACItem_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Rights.ACItem_LV",
                    null,
                ),
                this.createLink(
                    "Rights.ACRelation_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Rights.ACRelation_LV",
                    null,
                ),
                this.createLink(
                    "UserRecycleBin_ERGNAMEPLURALIZED",
                    "DetailView?TypeName=RAD.RADFoundation.ProblemDomain.UserRecycleBin&Action=CREATE",
                    null,
                ),
            ],
        });
        this.adminElement = new this.StartpageElementViewModel({
            label: new this.LabelViewModel({
                ergName: "RADFoundation_Subsystem_Administration_ERGNAME",
            }),
            items: [
                this.createLink(
                    "Domain_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Domain_LV",
                    null,
                ),
                this.createLink(
                    "Financial.Currency_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Financial.Currency_LV",
                    "Currency",
                ),
                this.createLink(
                    "LDAP.RADLdapConnection_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.LDAP.RADLdapConnection_LV",
                    "LDAP.RADLdapConnection",
                ),
                this.createLink(
                    "LDAP.RADAzureADConnection_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.LDAP.RADAzureADConnection_LV",
                    "LDAP.RADAzureADConnection",
                ),
                this.createLink(
                    "Meta.Transfer.PDMetadataTransfer_ERGNAME",
                    "DetailView?TypeName=RAD.RADFoundation.ProblemDomain.Meta.Transfer.PDMetadataTransfer",
                    "Meta.Transfer.PDMetadataTransfer",
                ),
                this.createLink(
                    "LDAP.RADLdapImport_ERGNAMEPLURALIZED",
                    "DetailView?TypeName=RAD.RADFoundation.ProblemDomain.LDAP.RADLdapImport&Action=CREATE",
                    "LDAP.RADLdapImport",
                ),
                this.createLink(
                    "Meta.PDApplicationMeta_ERGNAME",
                    "DetailView?TypeName=RAD.RADFoundation.ProblemDomain.Meta.PDApplicationMeta",
                    "Meta.PDApplicationMeta",
                ),
                this.createLink(
                    "Meta.PDExtensionModuleMeta_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.PDExtensionModuleMeta_LV",
                    null,
                ),
                this.createLink(
                    "PDPrincipal_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.PDPrincipal_LV",
                    "PDPrincipal",
                ),
                this.createLink(
                    "SmtpConnection_ERGNAMEPLURALIZED",
                    "DetailView?TypeName=RAD.RADFoundation.ProblemDomain.SmtpConnection&Action=CREATE",
                    "SmtpConnection",
                ),
                this.createLink(
                    "SystemProperty_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.SystemProperty_LV",
                    "SystemProperty",
                ),
            ],
        });
        this.metaElement = new this.StartpageElementViewModel({
            label: new this.LabelViewModel({
                ergName: "RADFoundation_Subsystem_Metadata_ERGNAME",
            }),
            items: [
                this.createLink(
                    "Localization.Language_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Localization.Language_LV",
                    null,
                ),
                this.createLink(
                    "Localization.ResourceItem_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Localization.ResourceItem_LV",
                    null,
                ),
                this.createLink(
                    "Meta.DetailView_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.DetailView_LV",
                    null,
                ),
                this.createLink(
                    "Meta.DetailView_DetailViewGroups_ERGNAME",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.DetailViewGroup_LV",
                    null,
                ),
                this.createLink(
                    "Meta.DVGItem_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.DVGItem_LV",
                    null,
                ),
                this.createLink(
                    "Meta.DynamicAssoziation_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.DynamicAssoziation_LV",
                    null,
                ),
                this.createLink(
                    "Meta.ListView_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.ListView_LV",
                    null,
                ),
                this.createLink(
                    "Meta.PDEnumerationMeta_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.PDEnumerationMeta_LV",
                    null,
                ),
                this.createLink(
                    "Meta.PDTypeMeta_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.PDTypeMeta_LV",
                    null,
                ),
                this.createLink(
                    "Meta.TreeNode_ERGNAMEPLURALIZED",
                    "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.TreeNode_LV",
                    null,
                ),
            ],
        });

        this.adminGroups = new this.StartpageGroupViewModel({
            elements: (() => {
                let elements = [];
                elements.push(
                    new this.StartpageElementViewModel({
                        label: new this.LabelViewModel({
                            ergName:
                                "RAD.RADFoundation.ProblemDomain.Meta.PDApplicationMeta_ERGNAME",
                        }),
                        items: [
                            this.createLink(
                                "History.HistorizationPoint_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.History.HistorizationPoint_LV",
                                "History.HistorizationPoint",
                            ),
                            this.createLink(
                                "Journal.JournalEntry_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Journal.JournalEntry_LV",
                                null,
                            ),
                            this.createLink(
                                "PDDocument_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.PDDocument_LV",
                                null,
                            ),
                            this.createLink(
                                "PDEMail_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.PDEMail_LV",
                                "PDEMail",
                            ),
                            this.createLink(
                                "PDJob_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Scheduler.PDJob_LV",
                                "Scheduler.PDJob",
                            ),
                        ],
                    }),
                );
                elements.push(
                    new this.StartpageElementViewModel({
                        label: new this.LabelViewModel({
                            ergName: "RADFoundation_Subsystem_Authorization_ERGNAME",
                        }),
                        items: [
                            this.createLink(
                                "User_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.User_LV",
                                "User",
                            ),
                            this.createLink(
                                "UserGroup_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.UserGroup_LV",
                                "UserGroup",
                            ),
                            this.createLink(
                                "UserMemberOf_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.UserMemberOf_LV",
                                null,
                            ),
                            this.createLink(
                                "Rights.ACItem_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Rights.ACItem_LV",
                                null,
                            ),
                            this.createLink(
                                "Rights.ACRelation_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Rights.ACRelation_LV",
                                null,
                            ),
                            this.createLink(
                                "UserRecycleBin_ERGNAMEPLURALIZED",
                                "DetailView?TypeName=RAD.RADFoundation.ProblemDomain.UserRecycleBin&Action=CREATE",
                                null,
                            ),
                        ],
                    }),
                );
                elements.push(
                    new this.StartpageElementViewModel({
                        label: new this.LabelViewModel({
                            ergName: "RADFoundation_Subsystem_Administration_ERGNAME",
                        }),
                        items: [
                            this.createLink(
                                "Domain_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Domain_LV",
                                null,
                            ),
                            this.createLink(
                                "Financial.Currency_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Financial.Currency_LV",
                                "Currency",
                            ),
                            this.createLink(
                                "LDAP.RADLdapConnection_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.LDAP.RADLdapConnection_LV",
                                "LDAP.RADLdapConnection",
                            ),
                            this.createLink(
                                "LDAP.RADAzureADConnection_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.LDAP.RADAzureADConnection_LV",
                                "LDAP.RADAzureADConnection_ERGNAMEPLURALIZED",
                            ),
                            this.createLink(
                                "Meta.Transfer.PDMetadataTransfer_ERGNAME",
                                "DetailView?TypeName=RAD.RADFoundation.ProblemDomain.Meta.Transfer.PDMetadataTransfer",
                                "Meta.Transfer.PDMetadataTransfer",
                            ),
                            this.createLink(
                                "LDAP.RADLdapImport_ERGNAMEPLURALIZED",
                                "DetailView?TypeName=RAD.RADFoundation.ProblemDomain.LDAP.RADLdapImport&Action=CREATE",
                                "LDAP.RADLdapImport",
                            ),
                            this.createLink(
                                "Meta.PDApplicationMeta_ERGNAME",
                                "DetailView?TypeName=RAD.RADFoundation.ProblemDomain.Meta.PDApplicationMeta",
                                "Meta.PDApplicationMeta",
                            ),
                            this.createLink(
                                "Meta.PDExtensionModuleMeta_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.PDExtensionModuleMeta_LV",
                                null,
                            ),
                            this.createLink(
                                "PDPrincipal_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.PDPrincipal_LV",
                                "PDPrincipal",
                            ),
                            this.createLink(
                                "SmtpConnection_ERGNAMEPLURALIZED",
                                "DetailView?TypeName=RAD.RADFoundation.ProblemDomain.SmtpConnection&Action=CREATE",
                                "SmtpConnection",
                            ),
                            this.createLink(
                                "SystemProperty_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.SystemProperty_LV",
                                "SystemProperty",
                            ),
                        ],
                    }),
                );
                elements.push(
                    new this.StartpageElementViewModel({
                        label: new this.LabelViewModel({
                            ergName: "RADFoundation_Subsystem_Metadata_ERGNAME",
                        }),
                        items: [
                            this.createLink(
                                "Localization.Language_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Localization.Language_LV",
                                null,
                            ),
                            this.createLink(
                                "Localization.ResourceItem_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Localization.ResourceItem_LV",
                                null,
                            ),
                            this.createLink(
                                "Meta.DetailView_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.DetailView_LV",
                                null,
                            ),
                            this.createLink(
                                "Meta.DetailView_DetailViewGroups_ERGNAME",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.DetailViewGroup_LV",
                                null,
                            ),
                            this.createLink(
                                "Meta.DVGItem_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.DVGItem_LV",
                                null,
                            ),
                            this.createLink(
                                "Meta.DynamicAssoziation_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.DynamicAssoziation_LV",
                                null,
                            ),
                            this.createLink(
                                "Meta.ListView_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.ListView_LV",
                                null,
                            ),
                            this.createLink(
                                "Meta.PDEnumerationMeta_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.PDEnumerationMeta_LV",
                                null,
                            ),
                            this.createLink(
                                "Meta.PDTypeMeta_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.PDTypeMeta_LV",
                                null,
                            ),
                            this.createLink(
                                "Meta.TreeNode_ERGNAMEPLURALIZED",
                                "ListView?ViewName=RAD.RADFoundation.ProblemDomain.Meta.TreeNode_LV",
                                null,
                            ),
                        ],
                    }),
                );
                return elements;
            })(),
        });

        this.favoritesElement = new StartpageElementViewModelT({
            label: new this.LabelViewModel({
                ergName: "FAVOURITE_TITLE",
            }),
            image: new this.ImageViewModel({
                // source: 'ModuleIconsLarge/favorites_large.png',
                alternativeText: new this.LabelViewModel({
                    ergName: "FAVOURITE_TITLE",
                }),
            }),
            items: this.defineComputed(() => {
                let menuItems = [
                    this.createItem({
                        ergName: "FAV_STARTPAGE",
                        url: "/Home",
                    }),
                    this.createItem({
                        ergName: "SEARCH_TITLE",
                        url: "/Search",
                    }),
                ];
                let menus = RADApplication.getInstance().user.menus();
                let favoriteTree = menus.userFavoriteTree;
                if (favoriteTree != null) {
                    for (let i = 0; i < favoriteTree.childNodes.length; i++) {
                        let item = this.createItem(favoriteTree.childNodes[i]);
                        menuItems.push(item);
                    }
                }
                let favorites = RADApplication.getInstance().user.getUserSpecificData(
                    "RAD_FAVOURITESITES",
                    {},
                )();
                for (let link in favorites) {
                    let favorite = this.createItem({
                        favoriteAddress: link,
                        ergName: favorites[link],
                    });
                    menuItems.push(favorite);
                }
                return menuItems;
            }),
        });

        this.tasksElement = new this.StartpageElementViewModel({
            label: new this.LabelViewModel({
                ergName: "RADFOUNDATION_SUBSYSTEM_TASKS_ERGNAME",
            }),
            items: (() => {
                let items = [];
                items.push(this.getMyTasksWithCount());
                items.push(
                    new this.LinkViewModel({
                        label: new this.LabelViewModel({
                            ergName: "TASKS_ALL_TASKS",
                        }),
                        onClick: () => {
                            NavigationService.getInstance().navigateToUrl(
                                "/ListView?TypeName=RAD.RADFoundation.ProblemDomain.PDTask&ViewName=RAD.RADFoundation.ProblemDomain.PDTask_LV&Filter=" +
                                encodeURIComponent("this.IsCompleted=false"),
                            );
                        },
                    }),
                );
                return items;
            })(),
        });
    }

    private createItem(item) {
        return new this.LinkViewModel({
            label: new this.LabelViewModel({
                ergName: item.ergName,
                tryToLoad: false,
                parentLocator: "startpage.favourites",
                locator: item.ergName,
            }),
            onClick: () => {
                if (item.favoriteAddress != null && item.favoriteAddress != "") {
                    NavigationService.getInstance().navigateToUrl(item.favoriteAddress);
                } else if (item.action != null && item.action != "") {
                    NavigationService.getInstance().loadViewFactory(item.action);
                } else if (item.url != null && item.url != "") {
                    NavigationService.getInstance().navigateToUrl(item.url);
                } else if (item.isListView === true) {
                    NavigationService.getInstance().navigateToUrl(
                        "/ListView?TypeName=" +
                        item.pdTypeName +
                        "&ViewId=" +
                        item.viewPDOID,
                    );
                } else if (item.pdTypeName != null && item.pdTypeName != "") {
                    NavigationService.getInstance().navigateToUrl(
                        "/DetailView?TypeName=" + item.pdTypeName,
                    );
                }
            },
        });
    }
    private getTasksSum(dtos: ITasksForTypeDTO[]): number {
        return _.reduce(
            dtos.map((x) => {
                return x.count;
            }),
            (a, b) => {
                return a + b;
            },
            0,
        );
    }

    private createLink(
        ergNameSuffix: string,
        navigationUrl: string,
        locatorTarget: string,
    ): LinkViewModelT {
        return new this.LinkViewModel({
            label: new this.LabelViewModel({
                ergName: `RAD.RADFoundation.ProblemDomain.${ergNameSuffix}`,
                locator:
                    locatorTarget !== null
                        ? this.getLinkLocator(
                            locatorTarget,
                            navigationUrl.includes("DetailView?"),
                        )
                        : null,
            }),
            onClick: () =>
                NavigationService.getInstance().navigateToUrl(navigationUrl),
        });
    }

    private getLinkLocator(locatorTarget: string, isDetailView: boolean): string {
        if (isDetailView) {
            return `startpage.edit-singleton.[RAD.RADFoundation.ProblemDomain.${locatorTarget}].label`;
        }

        return `startpage.open-list.[RAD.RADFoundation.ProblemDomain.${locatorTarget}].label`;
    }

    private getMyTasksWithCount(): LinkViewModelT {
        const taskInformationObs = RADApplication.getInstance().user.taskInformation;
        const builder = new LinkViewModelBuilder()
            .withOnClick(() =>
                NavigationService.getInstance().navigateToUrl(
                    "/ListView?TypeName=RAD.RADFoundation.ProblemDomain.PDTask&ViewName=RAD.RADFoundation.ProblemDomain.PDTask_LV&Filter=" +
                    encodeURIComponent(
                        "this.Assignee.PDO_ID=" +
                        RADApplication.getInstance().user.pdoId() +
                        " AND this.IsCompleted=false",
                    ),
                ),
            )
            .withLabel()
            .withErgName("TASKS_MY_TASKS_WITH_COUNT");

        builder.withPostfix().updateProperties({
            isVisible: this.defineComputed(() => {
                const taskInformation = taskInformationObs();
                return taskInformation.allAssignedTasks.length > 0;
            }),
            caption: this.defineComputed(() => {
                const taskInformation = taskInformationObs();
                if (taskInformation) {
                    return `(${this.getTasksSum(taskInformation.allAssignedTasks).toString()})` ;
                } else {
                    return '';
                }
            })
        });

        return builder.done().build();
    }
}

ComponentManager.setViewModel(
    "StartpageViewModel",
    StartpageViewModel,
    "RADPresentation.HTMLClient.DefaultViewExtensions",
);
